<template>
  <div class="level-status">
    <span class="level-status__badge" :class="badgeClass">{{ label }}</span>
    <span v-if="missingLabels.length" class="level-status__missing">
      Faltan: {{ missingLabels.join(', ') }}
    </span>
    <span v-if="projected" class="level-status__projected">Nivel proyectado</span>
  </div>
</template>

<script>
const NO_ORDERS = 0;

export default {
  name: 'LevelStatusBadge',
  props: {
    period: { type: Object, required: true },
    thresholds: { type: Array, default: () => [] }
  },
  computed: {
    withoutOrders() {
      return Number(this.period.orders_count) === NO_ORDERS;
    },
    missingMetrics() {
      return Array.isArray(this.period.missing_metrics) ? this.period.missing_metrics : [];
    },
    isComplete() {
      return (
        this.period.has_alert === false &&
        this.missingMetrics.length === 0 &&
        !this.withoutOrders
      );
    },
    projected() {
      return this.period.is_closed === false;
    },
    label() {
      if (this.isComplete) {
        return 'Datos completos';
      }
      if (this.withoutOrders) {
        return 'Sin pedidos';
      }

      return 'Datos incompletos';
    },
    badgeClass() {
      return this.isComplete ? 'level-status__badge--ok' : 'level-status__badge--warn';
    },
    missingLabels() {
      return this.missingMetrics.map(metric => {
        const threshold = this.thresholds.find(candidate => candidate.metric === metric);

        return threshold ? threshold.label : metric;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.level-status {
  display: flex;
  flex-direction: column;
  line-height: 1.35;
}
.level-status__badge {
  display: inline-block;
  width: fit-content;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  border-radius: 10px;
}
.level-status__badge--ok {
  color: #3d9e68;
  background: rgba(93, 188, 133, 0.12);
}
.level-status__badge--warn {
  color: #a2681a;
  background: rgba(251, 176, 59, 0.16);
}
.level-status__missing,
.level-status__projected {
  font-size: 0.7rem;
  color: #8a988f;
}
</style>
